import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { getIntegrations, formatApiError } from "@/auth";
import { AuthShell } from "@/components/AuthShell";
import { ServiceTitanCard, ComingSoonGrid, CertificateEmailCard } from "@/components/IntegrationsModal";

export default function ConnectFsm() {
  const [data, setData] = useState(null);
  const nav = useNavigate();
  const load = () => getIntegrations().then(setData).catch((e) => {
    if (e?.response?.status === 401) nav("/login", { replace: true }); else toast.error(formatApiError(e));
  });
  useEffect(() => { load(); }, []);
  const done = () => nav("/", { replace: true });

  return (
    <AuthShell wide testId="connect-fsm-screen" title="Connect your field-service platform" subtitle="Optional. Link the system your team already uses so completed installs flow into R.U.A.C.H. automatically and certificates flow back. You can also do this later from Integrations on the dashboard.">
      {!data ? <div className="flex justify-center py-8 text-slate-400"><Loader2 className="h-5 w-5 animate-spin" /></div> : (
        <div className="space-y-3">
          <ServiceTitanCard data={data} reload={load} canEdit compact />
          <ComingSoonGrid providers={data.providers} />
          <CertificateEmailCard data={data} reload={load} canEdit />
        </div>
      )}
      <button data-testid="connect-fsm-continue" onClick={done} className="mt-5 flex w-full items-center justify-center gap-2 rounded-xl bg-orange-600 py-2.5 font-semibold text-white transition-colors hover:bg-orange-500">
        {data?.servicetitan || data?.email_certificates ? "Continue to dashboard" : "Skip for now"} <ArrowRight className="h-4 w-4" />
      </button>
    </AuthShell>
  );
}
